import React, {useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { httpGet , crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";
import { languagePicker, getLabel } from '../../utils';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTh , faList } from '@fortawesome/free-solid-svg-icons';
import ShowsPageHolder from './ShowsPageStyle';
import ListItem from '../../components/ListItem/ListItem';
import SEO from '../../components/SEO/SEO';

const ShowsPage = (props) => {
    const [title, setTitle] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [programList, setProgramsList] = useState([]);
    const [viewType , setViewType] = useState("grid");
    const [pageDesc, setPageDesc] = useState('');
    const [pageThumb, setPageThumb] = useState([]);
	const siteURL = window.location.origin;
	const pageURL = window.location.origin + window.location.pathname;
	const pageLang = props.current_lang;
	const pageLocale = pageLang + "_CA";
	const pageTitle = title + " | CPAC.ca";

    useEffect(() => {
        const craftConf = crafterConf.getConfig();
        const serviceUrl = composeUrl(craftConf , process.env.REACT_APP_CONTENT_MODEL_ENDPOINT);

        httpGet(serviceUrl, {url: props.url , crafterSite: craftConf.site}).subscribe((data) => {
            let fieldNames = [ "title_t",
                "itemList;title_t", "itemList;seeAllUrl_s",
                "itemList.title_t", "itemList.description_t", "itemList.image_s", "itemList.altImageTxt_s",
                "itemList.url_s", "itemList.category_t", "itemList.categoryURL_s",
                "programsList.title_t", "programsList.url_s", 
                "thumbnailResult.image_s", "thumbnailResult.altImageTxt_s"
            ]
            languagePicker(data, fieldNames);
            let dataPage = data.page;
            setTitle(dataPage.title);
            setPageThumb(dataPage.thumbnailResult.item[0].image);
            if (dataPage.itemList) {
                setItemList(dataPage.itemList);
            }
            if (dataPage.programsList){

                const sortedProgramList = dataPage.programsList.item.sort((a, b) => a.title.localeCompare(b.title));

                const groupedData = sortedProgramList.reduce((r, e) => {
                    let group = e.title[0].normalize('NFD').replace(/[\u0300-\u036f]/g, "");

                    if(!r[group]) {
                        r[group] = {group, items: [e]}
                    } 
                    else {
                        r[group].items.push(e);
                    } 

                    return r;
                }, {});

                setProgramsList(groupedData);
            }
        });
        if(props.current_lang === "en"){
			setPageDesc("Programs on CPAC");
		} else {
			setPageDesc("Des émissions à CPAC");
		}

    }, [props.url, props.current_lang]);
     
    useEffect(()=> {
        props.setCurrentLanguage(props.lan);
    },[props.lan]);

    const renderItems = (items) => {
        return items.map((item, i) => {
            return (
                <a key={ `item-${i}` } href={ item.url } className="featured-container__small-item" tabIndex="0" itemProp="itemListElement">
                    <p className="item-title" itemProp='name'>{ item.title }</p>
                </a>
            )
        })
    }

    const renderList = () => {
        const list = Object.keys(programList);
        return list.map((key, i) => {
            const element = programList[key];
            return (
                <div key={ `list-${i}` } itemScope itemType='https://schema.org/ItemList'>
                    <h2 className="program-grp-lt" tabIndex="0" itemProp='category'>{ element.group }</h2>
                    {renderItems(element.items)}
                </div>
            )
        })
    }

    return (
        <>
        <SEO pageDesc={pageDesc} pageURL={pageURL} title={title}  pageTitle={pageTitle} image={siteURL + pageThumb} pageLocale={pageLocale} />
        <ShowsPageHolder>
			<h1 className="page-title" tabIndex="0" itemProp='headline'>{title}</h1>
            <div className="v-selectBtns-container" itemProp='potentialAction'>
                <button onClick={()=>{setViewType("grid")}} itemProp='accessMode'><span tabIndex="0"><FontAwesomeIcon icon={faTh} />{getLabel("THUMBNAILS")}</span></button>
                <button onClick={()=>{setViewType("list")}} itemProp='accessMode'><span tabIndex="0"><FontAwesomeIcon icon={faList} />{getLabel("LIST")}</span></button>
            </div>
            {viewType === "grid" && itemList && <ListItem items={itemList}/> }
            {viewType === "list" && programList && <div className="list-container">{renderList()}</div> }
        </ShowsPageHolder>
        </>
    )
}

const mapStateToProps = (store) => ({
    current_lang: store.language.current,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentLanguage: (lang) => dispatch({ type: 'SET_CUR_LANG', current: lang })
});

export default connect(mapStateToProps,mapDispatchToProps)(ShowsPage);